import HttpRequest from '@/util/HttpRequest'

export default {

  /**
   * 위험평가 항목 제안 (유해위험요인 설명 목록 생성)
   * @params {사업장명, 공종명, 작업내용, 소속명, 부서명}
   */
  async GET_RISK_SUBTASKS({commit}, params) {
    const option = {
      사업장명: params.사업장명, // 필수
      공종명: params.공종명 || '',
      작업내용: params.작업내용, // 필수
      소속명: params.소속명 || '',
      부서명: params.부서명 || ''
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/risk-subtasks', { params: option })
        .then(response => {
          commit('SET_RISK_SUBTASKS', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 재난 유형 정의
   * @params {세부작업명}
   */
  async DEFINE_RISK_TYPE({commit}, params) {
    const option = {
      세부작업명: params.세부작업명, // 필수
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/define-risk-type', { params: option })
        .then(response => {
          commit('SET_RISK_TYPE', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 현재 안전보건조치 제안
   * @params {평가구분, 유해위험요인, 설명, 재해형태}
   */
  async GET_CURRENT_SAFETY_MEASURES({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명 || '',
      재해형태: params.재해형태 || ''
    }

    // 최소 1개 이상의 파라미터 확인
    const hasParams = Object.values(option).some(value => value !== '')
    if (!hasParams) {
      return Promise.reject(new Error('평가구분, 유해위험요인, 설명, 재해형태 중 최소 1개 이상의 정보를 입력해주세요'))
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/current-safety-measures', { params: option })
        .then(response => {
          commit('SET_CURRENT_SAFETY_MEASURES', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 현재 위험도 점수 제안 (가능성, 중대성, 위험성)
   * @params {평가구분, 유해위험요인, 설명, 재해형태, 현재조치}
   */
  async MEASURE_CURRENT_RISK_POINT({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명, // 필수
      재해형태: params.재해형태 || '',
      현재조치: params.현재조치 || ''
    }

    if (!option.설명) {
      return Promise.reject(new Error('설명은 필수 항목입니다'))
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/measure-current-risk-point', { params: option })
        .then(response => {
          commit('SET_CURRENT_RISK_POINT', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 위험감소대책 제안
   * @params {평가구분, 유해위험요인, 설명, 재해형태, 현재조치, 가능성, 중대성}
   */
  async GET_RISK_REDUCTIONS({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명, // 필수
      재해형태: params.재해형태 || '',
      현재조치: params.현재조치 || '',
      가능성: params.가능성 || '',
      중대성: params.중대성 || ''
    }

    if (!option.설명) {
      return Promise.reject(new Error('설명은 필수 항목입니다'))
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/risk-reductions', { params: option })
        .then(response => {
          commit('SET_RISK_REDUCTIONS', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 개선후 위험도 점수 제안
   * @params {평가구분, 유해위험요인, 설명, 재해형태, 현재조치, 가능성, 중대성, 위험감소대책}
   */
  async MEASURE_AFTER_RISK_POINT({commit}, params) {
    const option = {
      평가구분: params.평가구분 || '',
      유해위험요인: params.유해위험요인 || '',
      설명: params.설명, // 필수
      재해형태: params.재해형태 || '',
      현재조치: params.현재조치 || '',
      가능성: params.가능성, // 필수
      중대성: params.중대성, // 필수
      위험감소대책: params.위험감소대책 // 필수
    }

    // 필수 파라미터 검증
    const requiredFields = ['설명', '가능성', '중대성', '위험감소대책']
    for (const field of requiredFields) {
      if (!option[field]) {
        return Promise.reject(new Error(`${field}은(는) 필수 항목입니다`))
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/miras/measure-after-risk-point', { params: option })
        .then(response => {
          commit('SET_AFTER_RISK_POINT', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 이미지 기반 위험성평가 분석
   * @params {image, content}
   * image: 분석할 이미지 파일 (File 객체)
   * content: 위험성평가 관련 정보 객체 (선택사항)
   *   - 예시: {사업장: "달지배수펌프장", 작업내용: "슬러지 제거 작업", 부서명: "시설관리팀"}
   */
  async ANALYZE_IMAGE_RISK({commit}, params) {
    // 필수 파라미터 검증
    if (!params.image) {
      return Promise.reject(new Error('이미지 파일은 필수 항목입니다'))
    }

    // FormData 생성
    const formData = new FormData()
    formData.append('image', params.image)

    // 컨텍스트 정보가 있으면 JSON 문자열로 추가
    if (params.content && typeof params.content === 'object') {
      // 빈 값이 아닌 항목만 필터링
      const filteredContent = Object.fromEntries(
        Object.entries(params.content).filter(([key, value]) =>
          value && String(value).trim() !== ''
        )
      )

      if (Object.keys(filteredContent).length > 0) {
        formData.append('content', JSON.stringify(filteredContent))
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/miras/image-analysis', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          commit('SET_IMAGE_RISK_ANALYSIS', response)
          resolve(response)
        })
        .catch(err => {
          // 에러 처리 및 사용자 친화적 메시지 제공
          let errorMessage = '이미지 분석 중 오류가 발생했습니다'

          if (err.response) {
            const { status, data } = err.response

            switch (status) {
              case 400:
                errorMessage = '잘못된 요청입니다. 이미지 파일을 확인해주세요'
                break
              case 406:
                errorMessage = 'AI 분석 서비스 설정에 문제가 있습니다. 관리자에게 문의하세요'
                break
              case 500:
                errorMessage = '서버 내부 오류가 발생했습니다. 잠시 후 다시 시도해주세요'
                break
              default:
                errorMessage = (data && data.error) || errorMessage
            }
          } else if (err.request) {
            errorMessage = '네트워크 연결을 확인해주세요'
          }

          reject(new Error(errorMessage))
        })
    })
  }
}
